import {errorMessage} from './error-message';

enum languageMsg {
    Column_Order_Header = "MAR.PURCHASE_ORDER.HeaderData.header",
    Column_Order_Content = "MAR.PURCHASE_ORDER.HeaderData.content",
    Column_Order_ResetOrder = "MAR.PURCHASE_ORDER.HeaderData.resetOrder",
    Column_Order_ApplyBtn = "MAR.PURCHASE_ORDER.Buttons.applyBtn",
    Column_Order_ClearBtn = "MAR.PURCHASE_ORDER.Buttons.clear_Btn",
    Filter_Popup_Label = "MAR.PURCHASE_ORDER.HeaderData.filterTitle",
    Filter_Popup_Status_All ="MAR.PURCHASE_ORDER.Statuslabel.DefaultValue",
    Filter_Popup_Validation_Search_History ="MAR.PURCHASE_ORDER.validation.Search_History",
    Filter_Popup_Validation_Required="MAR.PURCHASE_ORDER.validation.Required",
    Add_Label ="MAR.Label.Add_Label",
    special_Character_Validation ="MAR.Validations.NoSpecialCharacter",
    special_Character_Dq_Validation ="MAR.Validations.NoSpecialCharacterDq",
    Decimal_Validation ="MAR.Validations.Decimal",
    Numeric_Validation ="MAR.Validations.Numeric",
    Required_Validation ="MAR.Validations.Required",
    NoRecordFound_Validation ="MAR.Validations.NoRecordFound",
    SelectFromList_Validation="MAR.Validations.SelectFromList",
    OnlyPositiveNumbers_Validation="MAR.Validations.OnlyPositiveNumbers",
    Load_More_Button ="BUTTON.loadmore",
    Search_History = "MAR.VIEWMANUAL_ORDER.pickupanddelivery.searchhistory",
    Popupmsg_Button_Close="PopUP_Msg.actionButtonCloseText",
    Popupmsg_Button_Cancel="PopUP_Msg.ConfirmLanguageChange.actionButtonCancelText",
    Server_error ="PopUP_Msg.serverError",
    Filter_Days="MAR.SEARCH_ORDER.searchFilter.days.",
    Filter_Months="MAR.SEARCH_ORDER.searchFilter.months.",
    CUSTOMER_CODE = "HD-FV",
    READONLYCUSTOMER_CODE = "HDNA"
}

let errorMsg  = errorMessage

export const Constant = { ...languageMsg, ...errorMsg};
